.validationContainer {
  max-width: 780px;
  width: 100%;
  margin: 0 auto;
}

.card {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-lg);
  padding: 1.05rem 1.15rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  box-shadow: var(--shadow-card);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
}

.titleWithInfo {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.title {
  margin: 0;
  font-family: var(--font-display);
  font-variant-numeric: tabular-nums;
  font-size: 1.05rem;
  font-weight: 800;
  color: #0d1c2e;
}

.infoIconBtn {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #eff4ff;
  border: 1px solid #d5e3fc;
  color: #00236f;
  font-family: var(--font-mono);
  font-size: 0.76rem;
  font-weight: 800;
  font-style: italic;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.infoIconBtn:hover {
  background: #dce9ff;
  color: #00236f;
}

.infoPopover {
  position: absolute;
  top: calc(100% + 0.45rem);
  left: 0;
  width: min(300px, calc(100vw - 2.5rem));
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 12px;
  padding: 0.8rem 0.9rem;
  box-shadow: 0 14px 32px rgba(13, 28, 46, 0.14);
  z-index: 110;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.infoPopoverTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  font-size: 0.78rem;
  font-weight: 700;
  color: #00236f;
}

.infoPopoverClose {
  background: transparent;
  border: none;
  color: #444651;
  font-size: 1.05rem;
  line-height: 1;
  cursor: pointer;
  padding: 0.1rem 0.3rem;
}

.infoPopoverBody {
  margin: 0;
  font-size: 0.76rem;
  color: #444651;
  line-height: 1.45;
}

.confidenceTag {
  padding: 0.16rem 0.52rem;
  border-radius: 6px;
  background: rgba(134, 242, 228, 0.35);
  color: #005049;
  border: 1px solid rgba(0, 106, 97, 0.25);
  font-family: var(--font-mono);
  font-weight: 700;
  font-size: 0.72rem;
  white-space: nowrap;
}

.hiddenInput {
  display: none;
}

/* El botón de subir imagen desde galería/archivo solo aparece en computadora (oculto en celular) */
.desktopOnlyUploadRow {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.cameraSecondaryBtn {
  background: #eff4ff;
  color: #00236f;
  border: 1px solid #d5e3fc;
  border-radius: var(--radius-md);
  padding: 0.65rem 0.95rem;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
}

.emptyScannerBox {
  background: #eff4ff;
  border: 1px dashed #93c5fd;
  border-radius: 14px;
  padding: 1.45rem 1.2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.emptyScannerIcon {
  font-size: 2.2rem;
  line-height: 1;
}

.emptyScannerTitle {
  font-family: var(--font-display);
  font-size: 0.95rem;
  font-weight: 800;
  color: #0d1c2e;
  margin: 0;
}

.emptyScannerText {
  font-size: 0.8rem;
  color: #444651;
  margin: 0;
  max-width: 480px;
  line-height: 1.45;
}

.emptyScannerActionBtn {
  padding: 0.68rem 1.15rem;
  min-height: 42px;
  border-radius: 10px;
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  border: 1px solid #00236f;
  box-shadow: 0 4px 12px rgba(0, 35, 111, 0.18);
  font-weight: 800;
  font-size: 0.84rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

/* Barra Superior de Aprobación con Miniatura Pequeña + Monto + Botón de Aprobar Arriba */
.topApprovalCard {
  background: rgba(134, 242, 228, 0.3);
  border: 1px solid rgba(0, 106, 97, 0.35);
  color: #005049;
  border-radius: 12px;
  padding: 0.82rem 0.9rem;
  display: flex;
  flex-direction: column;
  gap: 0.72rem;
}

.topSummaryRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.7rem;
}

.miniThumbWrapper {
  flex-shrink: 0;
}

.miniReceiptThumb {
  width: 44px;
  height: 56px;
  border-radius: 6px;
  border: 1px solid #c5c5d3;
  object-fit: cover;
  background: #ffffff;
  display: block;
}

.miniReceiptPlaceholder {
  width: 44px;
  height: 56px;
  border-radius: 6px;
  border: 1px dashed #c5c5d3;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
}

.topMerchantBlock {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.14rem;
}

.topMerchantLabel {
  font-family: var(--font-mono);
  font-size: 0.68rem;
  color: #005049;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topMerchantName {
  font-family: var(--font-display);
  font-size: 0.9rem;
  font-weight: 800;
  color: #0d1c2e;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topAmountEditor {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  flex-shrink: 0;
}

.topAmountCurrency {
  font-family: var(--font-display);
  font-size: 0.92rem;
  font-weight: 800;
  color: #00236f;
}

.topAmountInput {
  width: 96px;
  background: #ffffff;
  border: 1px solid #c5c5d3;
  border-radius: 8px;
  padding: 0.32rem 0.45rem;
  color: #00236f;
  font-family: var(--font-display);
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  font-size: 1.02rem;
  text-align: right;
}

.topAmountInput:focus {
  border-color: #00236f;
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.12);
  outline: none;
}

.issueDateValidationRow {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 0.35rem;
  border-top: 1px dashed rgba(0, 106, 97, 0.3);
}

.issueDateFieldGroup {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.issueDateLabel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.6rem;
  width: 100%;
  font-size: 0.78rem;
  font-weight: 700;
  color: #0d1c2e;
}

.issueDateInput {
  background: #ffffff;
  border: 1px solid #c5c5d3;
  border-radius: 8px;
  padding: 0.35rem 0.6rem;
  color: #0d1c2e;
  font-family: var(--font-mono);
  font-size: 0.82rem;
  font-weight: 700;
}

.issueDateInput:focus {
  border-color: #00236f;
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.12);
  outline: none;
}

.periodBadgeActive {
  padding: 0.42rem 0.7rem;
  border-radius: 8px;
  background: rgba(134, 242, 228, 0.4);
  border: 1px solid rgba(0, 106, 97, 0.35);
  color: #005049;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.35;
}

.periodBadgeOther {
  padding: 0.42rem 0.7rem;
  border-radius: 8px;
  background: #fef3c7;
  border: 1px solid #f59e0b;
  color: #92400e;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.35;
}

.metaInlineInput,
.metaInlineSelect {
  background: #ffffff;
  border: 1px solid #c5c5d3;
  border-radius: 8px;
  padding: 0.3rem 0.48rem;
  color: #0d1c2e;
  font-family: var(--font-mono);
  font-size: 0.76rem;
  font-weight: 600;
  width: 100%;
}

.metaInlineInput:focus,
.metaInlineSelect:focus {
  border-color: #00236f;
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.12);
  outline: none;
}

.topActionButtonsRow {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.confirmBtnTop {
  flex: 1;
  padding: 0.72rem 0.95rem;
  border-radius: 10px;
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  border: 1px solid #00236f;
  box-shadow: 0 4px 12px rgba(0, 35, 111, 0.18);
  font-weight: 800;
  font-size: 0.86rem;
  cursor: pointer;
}

.confirmBtnTop:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cancelBtnTop {
  padding: 0.72rem 0.82rem;
  border-radius: 10px;
  background: #eff4ff;
  border: 1px solid #d5e3fc;
  color: #00236f;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

/* Estado de análisis IA en curso */
.scanningAlertBox {
  padding: 0.85rem;
  border-radius: 10px;
  background: rgba(134, 242, 228, 0.3);
  border: 1px solid rgba(0, 106, 97, 0.35);
  color: #005049;
  font-size: 0.84rem;
}

.scanningHeaderRow {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.scanningSubtext {
  margin: 0.2rem 0 0 0;
  font-size: 0.76rem;
  color: #005049;
}

.errorAlertBox {
  padding: 0.65rem 0.85rem;
  border-radius: 8px;
  background: #ffdad6;
  border: 1px solid rgba(186, 26, 26, 0.28);
  color: #93000a;
  font-size: 0.82rem;
}

/* Bloque de Datos Extraídos de la Boleta */
.receiptPaper {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-md);
  padding: 0.85rem 0.95rem;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  font-family: var(--font-mono);
  font-size: 0.76rem;
  font-variant-numeric: tabular-nums;
}

.metaGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
}

.metaItem {
  display: flex;
  flex-direction: column;
  gap: 0.08rem;
}

.metaLabel {
  font-size: 0.65rem;
  color: #444651;
  text-transform: uppercase;
  font-weight: 700;
}

.metaValue {
  font-weight: 700;
  color: #0d1c2e;
  word-break: break-word;
}

.itemsList {
  border-top: 1px dashed #c5c5d3;
  border-bottom: 1px dashed #c5c5d3;
  padding: 0.5rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.32rem;
}

.itemRow {
  display: flex;
  justify-content: space-between;
  gap: 0.65rem;
  color: #0d1c2e;
}

.impactInlineBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.45rem;
  font-size: 0.73rem;
  color: #444651;
}

.impactInlineHighlight {
  color: #00236f;
  font-weight: 700;
}

.toggleSamplesBtn {
  background: #eff4ff;
  border: 1px dashed #d5e3fc;
  color: #00236f;
  border-radius: var(--radius-sm);
  padding: 0.5rem 0.75rem;
  font-size: 0.76rem;
  font-weight: 700;
  cursor: pointer;
  text-align: left;
}

.samplesGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.6rem;
}

.sampleBtn {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-md);
  padding: 0.68rem 0.8rem;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.22rem;
  cursor: pointer;
}

.sampleBtnActive {
  border-color: #00236f;
  background: #dce9ff;
}

.sampleBadge {
  font-family: var(--font-mono);
  font-size: 0.65rem;
  font-weight: 700;
  color: #00236f;
}

.sampleName {
  font-size: 0.8rem;
  font-weight: 700;
  color: #0d1c2e;
}

.sampleMeta {
  font-size: 0.7rem;
  color: #444651;
}

@media (max-width: 900px) {
  .desktopOnlyUploadRow {
    display: none;
  }

  .card {
    padding: 0.9rem 0.95rem;
    gap: 0.72rem;
  }
}

@media (max-width: 580px) {
  .samplesGrid {
    grid-template-columns: 1fr;
  }
}

/* Selector 1-Tap de Tarjeta de Crédito / Débito y Captura de App Bancaria */
.paymentSelectorBox {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: 10px;
  padding: 0.72rem 0.85rem;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.paymentSelectorHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.paymentSelectorLabel {
  font-size: 0.72rem;
  font-weight: 800;
  color: #00236f;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.docTypeSelect {
  background: #ffffff;
  border: 1px solid #c5c5d3;
  color: #0d1c2e;
  border-radius: 10px;
  padding: 0.28rem 0.55rem;
  font-size: 0.72rem;
  font-weight: 700;
  outline: none;
}

.docTypeSelect:focus {
  border-color: #00236f;
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.12);
}

.paymentChipsRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.paymentChipBtn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.72rem;
  border-radius: 8px;
  background: #eff4ff;
  border: 1px solid #d5e3fc;
  color: #00236f;
  font-size: 0.76rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
}

.paymentChipBtnActive {
  border-color: #00236f;
  background: #00236f;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 35, 111, 0.22);
}

.paymentChipSubTag {
  font-size: 0.65rem;
  font-family: var(--font-mono);
  opacity: 0.88;
}

.cardLimitAlertBanner {
  padding: 0.52rem 0.72rem;
  border-radius: 8px;
  background: #fef3c7;
  border: 1px solid #f59e0b;
  color: #92400e;
  font-size: 0.75rem;
  line-height: 1.35;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.switchCardAlertBtn {
  padding: 0.28rem 0.6rem;
  border-radius: 6px;
  border: 1px solid #00236f;
  background: #00236f;
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 800;
  cursor: pointer;
}

.periodBadgeNextCycle {
  background: #dce9ff;
  color: #00236f;
  border: 1px solid #93c5fd;
}

.aiMatchedCardBanner {
  padding: 0.52rem 0.72rem;
  border-radius: 8px;
  background: rgba(134, 242, 228, 0.3);
  border: 1px solid rgba(0, 106, 97, 0.35);
  color: #005049;
  font-size: 0.76rem;
  font-weight: 600;
  line-height: 1.38;
}

.aiMissingDigitsBanner {
  padding: 0.52rem 0.72rem;
  border-radius: 8px;
  background: #fef3c7;
  border: 1px solid #f59e0b;
  color: #92400e;
  font-size: 0.76rem;
  font-weight: 600;
  line-height: 1.38;
}

.cardSelectRow {
  display: flex;
  align-items: center;
  width: 100%;
}

.cardDropdownSelect {
  width: 100%;
  background: #ffffff;
  border: 1px solid #c5c5d3;
  color: #0d1c2e;
  border-radius: 10px;
  padding: 0.45rem 0.65rem;
  font-size: 0.78rem;
  font-weight: 700;
  outline: none;
}

.cardDropdownSelect:focus {
  border-color: #00236f;
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.12);
}
